// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"be802e1e","402":"f19113b4"}[chunkId] + ".chunk.js";
};